export const ORG_COOKIE_KEY = 'cci-org-analytics-id';
export const HEADER_HEIGHT = 126;
